import { render } from "./CandidateProfileWork.vue?vue&type=template&id=945d2c44&scoped=true"
import script from "./CandidateProfileWork.vue?vue&type=script&lang=js"
export * from "./CandidateProfileWork.vue?vue&type=script&lang=js"

import "./CandidateProfileWork.vue?vue&type=style&index=0&id=945d2c44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945d2c44"]])

export default __exports__